import Reflux from 'reflux';

const RevisionActions = Reflux.createActions([
  // New data is applied to the store
  'update',
  'selectRevisionScan',

  // Fetch update from server and apply
  'load',
  'loadMinimal',
  'invalidateCache',
  'scan',
  'rebuild',
]);

export default RevisionActions;
